import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Profile from "./Profile";
import Images from "./Images";
import NotFound from "../NotFound";
const ViewProfile = ({ match, updateHeader, updateBreadcrumb }) => {
  return (
    <Switch>
      <Route
        path={`${match.url}/:profileId`}
        exact
        render={props => (
          <Profile
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        path={`${match.url}/:profileId/images`}
        exact
        render={({ history, match }) => (
          <Images
            match={match}
            history={history}
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
      <Route
        render={props => (
          <NotFound
            updateHeader={updateHeader}
            updateBreadcrumb={updateBreadcrumb}
          />
        )}
      />
    </Switch>
  );
};

export default ViewProfile;



// WEBPACK FOOTER //
// ./src/_components/ViewProfile/index.js